// extracted by mini-css-extract-plugin
export var badge = "_fv-2";
export var detailsPanel = "_fv-0";
export var resultRow = "_fv-1";